import React from 'react';
import { Box, Typography, Paper, Button, Alert } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout/Layout';

const DebugPage = () => {
  console.log('🐛 DebugPage: Renderizando página de debug');
  const { user, isAuthenticated, loading, token, login, logout } = useAuth();

  const handleTestLogin = async () => {
    console.log('🐛 DebugPage: Testando login...');
    try {
      const result = await login({ email: 'admin@teste.com', password: 'admin123' });
      console.log('🐛 DebugPage: Resultado do login:', result);
    } catch (error) {
      console.error('🐛 DebugPage: Erro no login:', error);
    }
  };

  const handleTestAPI = async () => {
    console.log('🐛 DebugPage: Testando API...');
    try {
      const response = await fetch('http://localhost:3002/api/health');
      const data = await response.json();
      console.log('🐛 DebugPage: Resposta da API:', data);
      alert('API funcionando! Veja o console para detalhes.');
    } catch (error) {
      console.error('🐛 DebugPage: Erro na API:', error);
      alert('Erro na API! Veja o console para detalhes.');
    }
  };

  return (
    <Layout>
      <Box sx={{
        p: 3,
        maxWidth: '1200px',
        mx: 'auto',
        width: '100%'
      }}>
        <Typography variant="h3" gutterBottom>
          🐛 Página de Debug
        </Typography>

        <Alert severity="info" sx={{ mb: 3 }}>
          Esta página mostra o status detalhado da autenticação e API
        </Alert>

        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h5" gutterBottom>
            🔐 Status da Autenticação:
          </Typography>
          <Typography>🔄 Loading: {loading ? 'true' : 'false'}</Typography>
          <Typography>✅ isAuthenticated: {isAuthenticated ? 'true' : 'false'}</Typography>
          <Typography>👤 User: {user ? user.name : 'Não autenticado'}</Typography>
          <Typography>🔑 Token: {token ? 'Presente' : 'Ausente'}</Typography>
          <Typography>📧 Email: {user ? user.email : 'N/A'}</Typography>
          <Typography>🏷️ Role: {user ? user.role : 'N/A'}</Typography>
        </Paper>

        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h5" gutterBottom>
            🧪 Testes:
          </Typography>
          <Button variant="contained" onClick={handleTestAPI} sx={{ mr: 2 }}>
            Testar API Backend
          </Button>
          <Button variant="outlined" onClick={handleTestLogin} sx={{ mr: 2 }}>
            Testar Login
          </Button>
          <Button variant="outlined" onClick={logout}>
            Logout
          </Button>
        </Paper>

        <Paper sx={{ p: 3 }}>
          <Typography variant="h5" gutterBottom>
            📊 Dados do Usuário (JSON):
          </Typography>
          <pre style={{ backgroundColor: '#f5f5f5', padding: '10px', borderRadius: '4px', overflow: 'auto' }}>
            {JSON.stringify(user, null, 2)}
          </pre>
        </Paper>
      </Box>
    </Layout>
  );
};

export default DebugPage;
